import { requestAsync } from 'redux-query';
import cfg from 'cfg';
import _ from 'lodash';

export const fetchEventFacts = (eventId, type) => (dispatch, getState) =>
    dispatch(
        requestAsync({
            queryKey: `${eventId}/facts/${type}`,
            url: `${cfg.apis.facts}/api/bulk-messages?props.eventId=${eventId}&type=${type}&locale=${_.get(
                getState(),
                'user.lang',
                'en'
            )}`,
            force: true,
            transform: res => ({
                [`${eventId}/facts/${type}`]: res
            }),
            update: {
                [`${eventId}/facts/${type}`]: (prev, next) => next
            }
        })
    );



/** WEBPACK FOOTER **
 ** ../src/dash/front/facts/actions/facts.js
 **/